import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router'
import "./HospitalityTrackV4.scss"
import { getOrderDetails } from "../../../RestaurantWidget/utilities/api/restaurantsService";
import { useDispatch } from "react-redux";
import { setOrderTrackingData } from "../../../../../../../redux/resturantWidgetSlice";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../RestaurantWidget/utilities/helper/helper";
import MenuNavbarMini from "../../components/Navbar/NavbarMini";
import CustomInput from "../../components/CustomInput/CustomInput";
import MenuFooter from "../../components/Footer/MenuFooter/MenuFooter";

const HospitalityTrackV4 = () => {
    const [value, setValue] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)
    const [errorText, setErrorText] = useState("")


    const history = useHistory()
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_TRACK_ORDER)
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        localStorage.removeItem("MODQUANTITY")
    }, [])
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null
    const updateState = (order) => {
        if (order.State === "CREATED" && order.PreparationStatus === "") {
            order.StateVal = "CREATED"
        }
        if (order.State === "CREATED" && order.PreparationStatus === "PREPARING") {
            order.StateVal = "PREPARING"
        }
        if (order.State === "CREATED" && order.PreparationStatus !== "" && order.Deliveries.Status === "SCHEDULED"
        ) {
            order.StateVal = "SCHEDULED"
        }
        if (order.State === "FINISHED") {
            order.StateVal = "FINISHED"
        }
        return order
    }
    return (
        <div className="HospitalityDefaultOrderPageV2">
            <MenuNavbarMini />
            <div className="order-cont-wrap">
                <div className="Order-track-container">
                    <div className="Order-track-container-header">Track your order
                    </div>
                    <div className="order-form">
                        <CustomInput
                            placeholder={"Enter your order number"}
                            label={"Please enter Order ID"}
                            value={value}
                            onChange={(e) => {
                                setValue(e.target.value)
                                setError(false)
                                setErrorText("")
                            }}
                            icon={"search"}
                            error={error}
                            errorText={errorText}
                            required
                        />

                        <div className="track-btn" onClick={() => {
                            if (value === "") {
                                setError(true)
                                setErrorText("*Order ID is required")
                            } else {
                                if (value !== "" && !isLoading) {
                                    setIsLoading(true)

                                    getOrderDetails(value, storeOrderLocalData.cloudLocationID).then((response) => {
                                        if (response) {
                                            dispatch(setOrderTrackingData(updateState(response)))
                                            setIsLoading(false)
                                            history.push("/order/status")

                                        }
                                    }).catch(() => {
                                        setIsLoading(false)
                                        setError(true)
                                        setErrorText("*Invalid Order ID. Please check the order number and try again.")
                                    })
                                }
                            }
                        }}>
                            {isLoading && <div className="loader-btn " />}
                            Track Order
                        </div>
                    </div>
                </div>
            </div>
            <MenuFooter />
        </div>

    )
}
export default HospitalityTrackV4